import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "NOTEPAGE" }
const _hoisted_2 = { id: "CONTENT" }

import i18n from "@/services/i18n";
import LearnEnglishPagePatternLayout from "../LearnEnglishPagePatternLayout.vue";
import { INoteRequest, INotesResponse } from "@/models/INote";
import {
  IS_DELETED,
  ORDER_BY,
  PAGE_FIRST,
  PAGE_SIZE_DEFAULT,
  QUERY_DEFAULT,
} from "@/utils/global";
import { onMounted, ref, onBeforeUnmount } from "vue";
import { getAll } from "@/api/noteApi";
import GridNotesComponent from "@/components/learn-english/notes/GridNotesComponent.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ListNote-page',
  setup(__props) {

const loading = ref(false);
const notesRes = ref<INotesResponse>({
  data: {
    results: [],
    page: 1,
    pageSize: PAGE_SIZE_DEFAULT,
    totalCount: 0,
    totalPages: 0,
  },
});
const noteReq = ref<INoteRequest>({
  query: QUERY_DEFAULT,
  page: PAGE_FIRST,
  pageSize:
    window.innerWidth <= 640 ? PAGE_SIZE_DEFAULT - 2 : PAGE_SIZE_DEFAULT + 2,
  is_deleted: IS_DELETED.is_False,
  orderBy: {
    column: ORDER_BY.COLUMN_DEFAULT,
    order: ORDER_BY.ORDER_DEFAULT,
  },
});

const handleFetchNotes = async () => {
  loading.value = true;
  try {
    const response = await getAll(noteReq.value);
    if (noteReq.value.page === 1) {
      notesRes.value = response;
    } else if (response.data?.results && notesRes.value?.data?.results) {
      notesRes.value.data.results.push(...response.data.results);
    }
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
  }
};

const handleScroll = () => {
  if (
    loading.value ||
    (noteReq.value.page !== undefined &&
      notesRes.value.data &&
      noteReq.value.page >= notesRes.value.data.totalPages)
  )
    return;
  const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
  if (scrollHeight - scrollTop <= clientHeight + 5) {
    if (noteReq.value.page !== undefined) {
      noteReq.value.page++;
    }
    handleFetchNotes();
  }
};

onMounted(() => {
  handleFetchNotes();
  window.addEventListener("scroll", handleScroll);
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", handleScroll);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LearnEnglishPagePatternLayout, {
    title: _unref(i18n).global.t('NOTE_SECTION.TITLE')
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[0] || (_cache[0] = _createElementVNode("div", {
          id: "ACTION",
          class: "flex justify-between navigation mb-2"
        }, null, -1)),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(GridNotesComponent, {
            notes: notesRes.value?.data?.results,
            loading: loading.value
          }, null, 8, ["notes", "loading"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})